module.exports = __webpack_public_path__ + "media/images/sp/visit_reserve/merit-cloud2-fd5b5675bf862c4b7d12a5976a7f5b06.png";